import { render, staticRenderFns } from "./settingsearch.vue?vue&type=template&id=93518320&scoped=true&"
import script from "./settingsearch.vue?vue&type=script&lang=js&"
export * from "./settingsearch.vue?vue&type=script&lang=js&"
import style0 from "./settingsearch.vue?vue&type=style&index=0&id=93518320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93518320",
  null
  
)

export default component.exports